/**
 * Role Name Mapping Utility
 *
 * Maps legacy role name ROLE_SELF to ROLE_DEFAULT for display in the UI.
 * This provides compatibility during the UCMS migration from ROLE_SELF to ROLE_DEFAULT.
 *
 * TODO: Remove this file after UCMS migration completes and all backend services
 * return ROLE_DEFAULT instead of ROLE_SELF. Set VITE_COMPAT_MAP_SELF_ROLE=false
 * and run build validation before removal.
 *
 * Related Ticket: PM-XXXXX (replace with actual ticket number)
 */

// Compatibility flag - set to false after UCMS migration completes
// Default: true (enabled during rollout)
// Hardcoded to true - environment variable removed to avoid import.meta.env issues in non-Vite contexts (Jest, Jenkins)
export const COMPAT_MAP_SELF_ROLE = true;

/**
 * Maps a single role name from ROLE_SELF to ROLE_DEFAULT
 * @param {string} role - The role name to map
 * @returns {string} The mapped role name
 */
export const mapRoleName = (role) => {
    if (!COMPAT_MAP_SELF_ROLE || !role) {
        return role;
    }
    return role === 'ROLE_SELF' ? 'ROLE_DEFAULT' : role;
};

/**
 * Maps an array of role names from ROLE_SELF to ROLE_DEFAULT
 * @param {Array<string>} roles - Array of role names to map
 * @returns {Array<string>} Array of mapped role names
 */
export const mapRoles = (roles) => {
    if (!roles || !Array.isArray(roles)) {
        return roles;
    }
    return roles.map(mapRoleName);
};
